import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccionCortoPlazoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getAccionPei(): Observable<any> {
    return this.http.get(this.baseUrl + 'accionPei', { headers: this.header(this.token) });
  }

  getAccionCortoPlazo(): Observable<any> {    
    return this.http.get(this.baseUrl + 'acpPOA', { headers: this.header(this.token) });
  }

  getIndicadorProcesoByAeiId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadorProcesoByAeiId/' + id, { headers: this.header(this.token) });
  }

  getIndicadoresRegistradosbyIdAcp(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadoresRegistradosbyIdAcp/' + id, { headers: this.header(this.token) });
  }

  postAccionCortoPlazo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaAccionCortoPlazo', bodyString, { headers: this.header(this.token) });
  }

  putAccionCortoPlazo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaAccionCortoPlazo', bodyString, { headers: this.header(this.token) });
  }

  deleteAccionCortoPlazo(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaAccionCortoPlazo/' + id, { headers: this.header(this.token) });
  }

  deleteIndicadorAei(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteIndicadorAei/' + id, { headers: this.header(this.token) });
  }

}
